import { kebabCase } from "lodash";
import { observer } from "mobx-react";
import React, { Component } from "react";
import thumbsUp from "../../../assets/images/like.svg";
import { COLORS } from "../../../shared/stateColors";
import { MainStore } from "../../../stores/MainStore";
import Label from "../../Label";
import TabView from "../../TabView";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
}

interface IState {}

@observer
class DetailsDoAndDonts extends Component<IProps, IState> {
  /**
   * return do list items
   */
  private prepareLis(listItems: string[] | string) {
    if (typeof listItems === "string") {
      return listItems;
    }

    return (
      <ul>
        {listItems.map(singleListItem => {
          return (
            <li
              key={Math.random()}
              dangerouslySetInnerHTML={{ __html: singleListItem }}
            />
          );
        })}
      </ul>
    );
  }

  render() {
    const { store } = this.props;
    const { selectedState } = store;

    if (!selectedState) return null;

    /// get state colors
    const stateColor = COLORS.filter(
      c => c.stateName === kebabCase(selectedState.name)
    )[0];

    return (
      <div className={classes.DetailsDoAndDonts}>
        <Label big bold id={"details.doanddonts"} />
        <TabView
          store={store}
          customColor={stateColor ? stateColor.colors.secondary : ""}
        >
          <div title={"Do"} data-titleicon={thumbsUp}>
            {selectedState.do && this.prepareLis(selectedState.do)}
          </div>
          <div title={"Don't"} data-titleicon={thumbsUp}>
            {selectedState.donts && this.prepareLis(selectedState.donts)}
          </div>
        </TabView>
      </div>
    );
  }
}
export default DetailsDoAndDonts;
